import React, { forwardRef } from 'react';

import { Spacer } from '@repo/ui/components/Spacer';

import { LayoutSwitch } from 'styles/queries';

import { ResponsiveSpacerProps } from './types';

const ResponsiveSpacer = forwardRef<HTMLSpanElement, ResponsiveSpacerProps>(
  ({ mw, dw, mh, dh, mobileBreakpoint }, ref) => {
    return (
      <LayoutSwitch
        desktopProps={{ width: dw, height: dh }}
        mobileBreakpoint={mobileBreakpoint}
        mobileProps={{ width: mw, height: mh }}
      >
        <Spacer ref={ref} />
      </LayoutSwitch>
    );
  }
);

ResponsiveSpacer.displayName = 'ResponsiveSpacer';

export default ResponsiveSpacer;
